module.exports = __webpack_public_path__ + "static/img/Corporativos.502ef95b.png";